function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/*********************************************************************************
 GAME PLAYER


 **********************************************************************************/
var GamePlayers = /*#__PURE__*/function () {
  function GamePlayers() {
    _classCallCheck(this, GamePlayers);
  }
  return _createClass(GamePlayers, [{
    key: "returnUsername",
    value:
    //
    // games can override this
    //
    function returnUsername() {
      var publickey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;
      return this.app.keychain.returnUsername(publickey, max);
    }
  }, {
    key: "returnPlayerUsername",
    value: function returnPlayerUsername() {
      var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      if (num >= this.game.players.length) {
        return 'Anon';
      }
      return this.returnUsername(this.game.players[num - 1]);
    }
  }, {
    key: "addPlayer",
    value: function addPlayer(address) {
      if (address === '') {
        return 0;
      }
      for (var i = 0; i < this.game.players.length; i++) {
        if (this.game.players[i] === address) {
          return 0;
        }
      }
      this.game.players.push(address);
      if (!this.game.accepted.includes(address)) {
        this.game.accepted.push(address);
      }
      if (this.publicKey !== address) {
        this.game.opponents.push(address);
      }
      return 1;
    }
  }, {
    key: "removePlayerFromState",
    value: function removePlayerFromState(address) {
      console.error('Did you define removePlayerFromState in your game module?');
      return null;
    }
  }, {
    key: "removePlayer",
    value: function removePlayer(address) {
      if (address === '') {
        return;
      }
      var player_final_state = this.removePlayerFromState(address);
      if (address === this.publicKey) {
        this.app.connection.emit('arcade-gametable-removeplayer', this.game.id, player_final_state);
        this.game.over = 2; // Hide in arcade...
      }
      for (var i = this.game.players.length - 1; i >= 0; i--) {
        if (this.game.players[i] === address) {
          var _this$game;
          this.game.players.splice(i, 1);
          this.game.keys.splice(i, 1);
          //this.game.accepted.splice(i, 1);

          if ((_this$game = this.game) !== null && _this$game !== void 0 && _this$game.opponent_decks) {
            if (this.game.opponent_decks["".concat(i + 1)]) {
              delete this.game.opponent_decks["".concat(i + 1)];
            }
          }
        }
      }
      for (var _i = 0; _i < this.game.opponents.length; _i++) {
        if (this.game.opponents[_i] === address) {
          this.game.opponents.splice(_i, 1);
        }
      }

      //
      // reassign player id's
      //
      this.game.player = 0;
      for (var _i2 = 0; _i2 < this.game.players.length; _i2++) {
        if (this.game.players[_i2] === this.publicKey) {
          this.game.player = _i2 + 1;
        }
      }

      //
      // track of players removed from the game
      // WARNING: do not confuse with tx.msg.options.eliminated, which is used for summaries in the Join overlay
      // We aren't using this yet, but doing an object to be consistent...
      //

      if (!this.game.options.eliminated) {
        this.game.options.eliminated = {};
      }
      this.game.options.eliminated[address] = true;
    }

    //
    // If other people are "watching" the game, we want to let all the players
    // know their address, so that game moves can be broadcast to them as well
    //
  }, {
    key: "addFollower",
    value: function addFollower(address) {
      console.info('GT Adding follower: ' + address);
      if (address === '') {
        return;
      }
      if (!this.game.accepted.includes(address)) {
        this.game.accepted.push(address);
        this.saveGame(this.game.id);
      }
    }
  }, {
    key: "returnLastPlayer",
    value: function returnLastPlayer() {
      var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.game.player;
      var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.game.players.length;
      target--;
      if (target < 1) {
        return max;
      }
      return target;
    }
  }, {
    key: "returnNextPlayer",
    value: function returnNextPlayer() {
      var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      num = parseInt(num) || this.game.player;
      num++;
      if (num > this.game.players.length) {
        return 1;
      }
      return num;
    }

    //////////////////////////////////////////////////////////////////
    // Player Turn is an archaic part of the game engine where we could
    // define a playerTurn function that runs whenever it is your turn
    // (this assumes what you can do at any part of the game is the same)
    // Most games don't rely on it, but it is necessary for simultaneous
    // moves
  }, {
    key: "nonPlayerTurn",
    value: function nonPlayerTurn() {
      this.hud.updateStatusMessage('Waiting for Opponent to Move');
    }
  }, {
    key: "playerTurn",
    value: function playerTurn() {
      var game_self = this;
      console.log("\n  This is the default Player Turn function. It should be replaced in any \n  game by code logic that specifies what players actually do. Their moves\n  should be added to the queue using addMove() and then endTurn() to \n  submit those moves to all other players.\n\n  Note that other players will execute the contents of this queue in \n  reverse order. Complicated game moves that require conditional should\n  be handled in .\n\n  The PLAY instruction does not \"fall-out\" automatically (it will keep \n  coming back to the player whose turn it is. This is deliberate design.\n  In order to remove this move, RESOLVE command must be issued by the \n  player whose turn it is. This will permit the queue to clear and \n  the game will continue with the next player.\n    ");
      game_self.addMove('RESOLVE\t' + this.publicKey);
      game_self.addMove('NOTIFY\tPlayer ' + game_self.game.player + ' has moved');
      game_self.endTurn();
    }
  }, {
    key: "setPlayerActive",
    value: function setPlayerActive() {
      var _this = this;
      var player = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      // It doesn't matter how playerTurn gets called, but we know it means
      // that we are waiting on input from this player and we will standardize
      // game.target as flag of whose turn the game is waiting on.
      if (player == null) {
        this.game.target = this.game.player;
      } else {
        this.game.target = player;
      }
      if (this.game.over == 0) {
        if (this.gameBrowserActive()) {
          if (this.useClock) {
            this.startClock(this.game.target);
          }
          if (this.game.target == this.game.player) {
            //
            // TODO - make opt-in
            //					this.setPlayReminder();
          }
        } else {
          // Notifications will read game from app.options, so need to wait a second to make sure
          // any saveGames complete
          var _this$game2 = this.game,
            id = _this$game2.id,
            target = _this$game2.target,
            status = _this$game2.status;
          setTimeout(function () {
            _this.app.connection.emit('arcade-notify-player-turn', id, target, status);
          }, 500);
        }
      }
    }
  }]);
}();
module.exports = GamePlayers;